// Buttons that ask something of the browser rather than of the server. One
// delegated listener each on the document, for the same reason navbar.js is
// written that way: Turbo replaces <body>, and a handler bound per element
// would not survive it. Neither is worth an island — an island is a component
// with state, and these are one call apiece.

// [data-print] opens the print dialog for the page it is on. The @media print
// rules in application.sass.scss are what decide how that page comes out.
document.addEventListener("click", (event) => {
  if (event.target.closest("[data-print]")) window.print()
})

// [data-copy-text] puts its own value on the clipboard and says so through the
// Toasts island, which the layout mounts on every page and which listens for
// this event on the document. A browser can refuse the clipboard outright, so
// the failure is reported rather than swallowed — the text is on screen next
// to the button either way, and being told nothing after clicking Copy is
// worse than being told it did not work.
document.addEventListener("click", async (event) => {
  const button = event.target.closest("[data-copy-text]")
  if (!button) return

  try {
    await navigator.clipboard.writeText(button.dataset.copyText)
    toast("notice", "Link copied")
  } catch {
    toast("alert", "Could not copy — select the link and copy it by hand.")
  }
})

function toast(type, message) {
  document.dispatchEvent(new CustomEvent("toast", { detail: { type, message } }))
}
